import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import determineLanguageDifferences from "../utils/determineLanguageDifferences";
import { getAdapter } from "../../../config/api";
var updatePreferredLanguages = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(contact, formValues) {
    var _context;
    var personId, preferredLanguages, _determineLanguageDif, languagesToAdd, languagesToRemove, addPromises, removePromises;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          personId = contact.id;
          preferredLanguages = (contact === null || contact === void 0 ? void 0 : contact.preferred_languages) || [];
          _determineLanguageDif = determineLanguageDifferences(preferredLanguages, formValues), languagesToAdd = _determineLanguageDif.languagesToAdd, languagesToRemove = _determineLanguageDif.languagesToRemove;
          addPromises = _mapInstanceProperty(languagesToAdd).call(languagesToAdd, function (record_language) {
            return getAdapter('coreApi').createRecord('record_language', {
              record_id: personId,
              record_type: 'Person',
              language_id: record_language.language_id,
              record_language_type: record_language.record_language_type
            });
          });
          removePromises = _mapInstanceProperty(languagesToRemove).call(languagesToRemove, function (record_language) {
            return getAdapter('coreApi').deleteRecord('record_language', record_language.id);
          });
          _Promise.all(_concatInstanceProperty(_context = []).call(_context, _toConsumableArray(addPromises), _toConsumableArray(removePromises)));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee);
  }));
  return function updatePreferredLanguages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export default updatePreferredLanguages;
//# sourceMappingURL=updatePreferredLanguages.js.map